import get from 'lodash.get'
import set from 'lodash.set'

export const deepClone = <T extends object>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj))
}

export const getProperty = <T>(obj: object, path: string[]): T =>
  path.length ? get(obj, path) : (obj as T)

export const setProperty = <T>(obj: object, path: string[], value: T): void => {
  path.length && set(obj, path, value)
}
